import { resolveAssignmentScores } from '@/lib/formsScoring';

export type CourseScoreRow = {
  label: string;
  value: number;
};

function asNumber(value: unknown): number | null {
  return typeof value === 'number' && Number.isFinite(value) ? value : null;
}

function preferPhysicalMental(rows: CourseScoreRow[]): CourseScoreRow[] {
  const physical = rows.find((row) => /physical|fysisk/i.test(row.label));
  const mental = rows.find((row) => /mental/i.test(row.label));
  if (physical && mental) return [physical, mental];
  return rows.slice(0, 2);
}

export function courseQuestionnaireScores(
  score: Record<string, unknown> | null | undefined,
): CourseScoreRow[] {
  if (!score) return [];
  const resolved = resolveAssignmentScores([], {}, null, score);
  if (resolved && resolved.domainScores.length > 0) {
    return preferPhysicalMental(
      resolved.domainScores.map((row) => ({
        label: row.domain,
        value: Math.round(row.score),
      })),
    );
  }
  const physical = asNumber(score.physical_sum) ?? asNumber(score.pcs);
  const mental = asNumber(score.mental_sum) ?? asNumber(score.mcs);
  if (physical != null && mental != null) {
    return [
      { label: 'physical', value: Math.round(physical) },
      { label: 'mental', value: Math.round(mental) },
    ];
  }
  return [];
}
